import { Box, Stack, Typography } from "@mui/material";
import styles from "./S1_FAQ.module.scss";
import { FAQTemplateProps } from "./FAQ";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { BrandNameUpdate } from "../../../utils";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";

const FAQComponent = (props: FAQTemplateProps) => {
  const { FAQ_title, QandA } = props.content || {};
  const [showAnswer, setShowAnswer] = useState<any>();

  const handleAnswer = (i: any) => {
    if (showAnswer === i) return setShowAnswer(null);
    return setShowAnswer(i);
  };

  return (
    <Stack
      sx={{
        backgroundColor: "var(--faq_background)",
        flexWrap: "wrap",
        alignItems: "center",
        py: { xs: "0px", sm: "30px" },
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", md: "60%" },
        }}
      >
        <Typography
          sx={{
            color: "var(--black)",
            fontSize: { xs: "26px", md: "30px" },
            fontFamily: "var(--font_family_Bold)",
            fontWeight: "var(--font_weight_4)",
            textAlign: "center",
            py: { xs: "20px", md: "30px" },
          }}
        >
          {FAQ_title}
        </Typography>
        {QandA?.map((item: any, i: any) => {
          return (
            <Box key={item.Q} sx={{ minHeight: { xs: "55px", md: "65px" } }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  alignItems: "center",
                  gap: "2px",
                }}
                onClick={() => {
                  handleAnswer(i);
                }}
              >
                <Typography
                  sx={{
                    color: "var(--faq-question)",
                    fontFamily: "var(--font_family_Semibold)",
                    fontWeight: "var(--font_weight_2)",
                    fontSize: { xs: "16px", md: "18px" },
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {item.Q}
                </Typography>
                {i !== showAnswer && (
                  <ExpandCircleDownIcon
                    sx={{
                      width: { xs: "20px", md: "26px" },
                      height: { xs: "20px", md: "26px" },
                      cursor: "pointer",
                    }}
                  />
                )}
                {i === showAnswer && (
                  <ExpandCircleDownIcon
                    sx={{
                      width: "26px",
                      height: "26px",
                      cursor: "pointer",
                      rotate: "180deg",
                    }}
                  />
                )}
              </Box>
              {i === showAnswer && (
                <Box
                  sx={{
                    background: "var(--faq_answer_bg)",
                    p: { xs: "25px", md: "45px" },
                    my: "20px",
                    borderRadius: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "var(--faq-answer)",
                      fontFamily: "var(--font_family_Regular)",
                      fontSize: "14px",
                      lineHeight: "30px",
                      "& p": {
                        margin: "0px",
                        fontWeight: "var(--font_weight_2)",
                        fontFamily: "var(--font_family_Semibold)",
                        fontSize: "16px",
                      },
                      "& span, li": {
                        margin: "0px",
                        fontFamily: "var(--font_family_Regular) !important",
                        fontWeight: "var(--font_weight_0) !important",
                        fontSize: "16px !important",
                      },
                      "& ul": {
                        margin: "0px",
                        paddingLeft: "27px",
                      },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: BrandNameUpdate(item.A),
                    }}
                  />
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
};

export default FAQComponent;
